import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { colors } from "../data/tokens";

// Chip de categoria de sócio com cor própria por família (contorno =
// classificação; o preenchido fica para situação/estado). Usado na
// lista de Sócios e na tela de Categorias de Sócios.
export const categoryChipColor = (
  name: string
): "primary" | "success" | "warning" | "info" | "default" => {
  const n = name.toLowerCase();
  if (n.includes("remido")) return "warning";
  if (n.includes("efetivo")) return "primary";
  if (n.includes("contribuinte")) return "success";
  if (n.includes("sênior") || n.includes("senior")) return "info";
  return "default";
};

export const CategoryChip = ({ name }: { name?: string }) => {
  if (!name) return null;
  return (
    <Chip
      size="small"
      variant="outlined"
      color={categoryChipColor(name)}
      label={name}
    />
  );
};

// Variante "legenda": bolinha colorida + nome em texto normal — usada
// na lista de Categorias, onde um chip por linha pesaria demais
export const CategoryDot = ({ name }: { name?: string }) => {
  if (!name) return null;
  const color = categoryChipColor(name);
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={(theme: any) => ({
          width: 10,
          height: 10,
          borderRadius: "50%",
          flexShrink: 0,
          backgroundColor:
            color === "default"
              ? colors.neutral300
              : theme.palette[color].main,
        })}
      />
      <Typography
        sx={{ fontSize: 13.5, fontWeight: 600, color: colors.primaryDark }}
      >
        {name}
      </Typography>
    </Box>
  );
};
